const FIL_CUSTOM = {
  accessToWifi: 'Magkaroon ng access sa Wi-Fi sa lokasyon ng pag-charge',
  AFTER_10PM_BEFORE_11AM: 'Pagkatapos ng 10pm; bago mag-11am',
  AFTER_11AM_BEFORE_10PM:
    'Pagkatapos ng 11:00 ng umaga; bago mag-10:00 ng gabi',
  AFTER_1230AM_BEFORE_930AM: 'Pagkatapos ng 12:30am; bago mag-9:30am',
  AFTER_12PM_BEFORE_8PM:
    'Pagkatapos ng alas-12 ng tanghali; bago mag-alas-8 ng gabi',
  AFTER_2PM_BEFORE_6PM:
    'Pagkatapos ng alas-2 ng hapon; bago mag-alas-6 ng gabi',
  AFTER_6AM_BEFORE_3PM:
    'Pagkatapos ng alas-6 ng umaga; bago mag-alas-3 ng hapon',
  AFTER_6PM_BEFORE_9AM: 'Pagkatapos ng 6pm; bago mag-9am',
  AFTER_8AM_BEFORE_MN: 'Pagkatapos ng alas-8 ng umaga; bago maghatinggabi',
  AFTER_9PM_BEFORE_6AM: 'Pagkatapos ng 9pm; bago mag-6am',
  AFTER_9PM_BEFORE_9AM: 'Pagkatapos ng 9pm; bago mag-9am',
  AFTER_MN_BEFORE_8AM: 'Pagkatapos ng hatinggabi; bago mag-8 ng umaga',
  'after.Incentives': 'PAGKATAPOS NG MGA INSENTIBO',
  age: 'Edad',
  agreeOffPeakSchedule:
    'Sumang-ayon na maningil sa isang iskedyul na hindi peak',
  all: 'Lahat',
  ALL_HOURS: 'Lahat ng oras (hindi mahuhulaan)',
  'assumption.downPayment': 'Paunang Bayad',
  'assumption.downPaymentValue': '10% ng MSRP + Buwis',
  'assumption.electricityRate': 'Bayad sa Kuryente',
  'assumption.gasolinePrice': 'Presyo ng Gasolina',
  'assumption.salesTax': 'Buwis sa Pagbebenta',
  'assumption.salesTaxPercent': 'Buwis sa Pagbebenta %',
  ATTACHED_GARAGE: 'Kalakip na Garahe',
  averageMonthlyCharge: 'KARANIWANG BUHAY NA BAYAD',
  averageMonthlyCharge_tool:
    'Piliin ang kabuuang singil sa kuryente (hindi kasama ang singil sa gas) sa isang karaniwang buwanang singil, anuman ang panahon. Ginagamit namin ang halagang ito upang tantyahin ang baseline para sa iyong kasalukuyang konsumo ng enerhiya.',
  basement: 'Silong',
  basicFilters: 'Mga Pangunahing Filter',
  certifiedElectrician: 'Sertipikadong elektrisyan',
  charger: 'CHARGER',
  chargeWithLevelTwoCharger:
    'Mag-charge gamit ang isang kwalipikadong Level 2 charger o magmaneho ng isang kwalipikadong electric vehicle',
  charging: 'Nagcha-charge',
  'chargingMap.businessGovernment': 'Ini-install ng negosyo o gobyerno',
  'chargingMap.DCChargers': 'DC fast charge o supercharger',
  'chargingMap.disclaimer':
    'Ang datos ay mula sa Alternative Fuel Data Center. Maaaring hindi maipakita ng mapa ang pinakabagong availability ng mga charging station.',
  'chargingMap.errorZipcode':
    'Error: Ang {workingZipcode} ay hindi isang wastong zipcode',
  'chargingMap.highPowerStations': 'Mga Istasyon ng Mataas na Enerhiya',
  'chargingMap.otherSttations': 'Iba Pang Uri ng mga Istasyon',
  'chargingMap.privateStations': 'Mga pribadong istasyon',
  'chargingMap.public': 'Mga pampublikong istasyon',
  'chargingMap.searchDealers': 'Maghanap ng mga Kwalipikadong Dealer',
  'chargingMap.showFullListOfStations': 'BUONG LISTAHAN NG MGA ISTASYON',
  'chargingMap.updateZipcode': 'I-update ang zip code',
  chargingStations: 'Mga Istasyon ng Pag-charge',
  'chargingStations.mapLegend.high': 'Mga Istasyon ng Mataas na Enerhiya',
  'chargingStations.mapLegend.highSubtext': 'DC fast charge o supercharger',
  'chargingStations.mapLegend.other': 'Iba Pang Uri ng mga Istasyon',
  'chargingStations.mapLegend.private': 'Mga Pribadong Istasyon',
  'chargingStations.mapLegend.public': 'Mga Pampublikong Istasyon',
  'chargingStations.mapLegend.publicSubtext':
    'Ini-install ng negosyo o gobyerno',
  'chargingWizard.carOvernight': 'Saan mo ipaparada ang kotse mo magdamag?',
  'chargingWizard.chargingAvailability': 'kakayahang mag-charge',
  'chargingWizard.electricianInstall':
    'Papayagan ba ang isang electrician na magkabit ng charging station?',
  'chargingWizard.noChargingAvailability': 'walang kakayahang mag-charge',
  'chargingWizard.onTheStreet': 'Sa kalye',
  'chargingWizard.overnightParking':
    'Maaari mo bang iparada ang kotse nang magdamag sa isang lugar na may charging station?',
  'chargingWizard.parkingGarage': 'Pribadong garahe o lugar para sa paradahan',
  'chargingWizard.powerOutlet':
    'Mayroon bang regular na saksakan ng kuryente malapit sa kung saan mo pinaparadahan ang iyong sasakyan?',
  'chargingWizard.publicParking': 'Pampublikong paradahan',
  'chargingWizard.useThisValue': 'Gamitin ang halagang ito',
  'chargingWizard.youWouldHave': 'magkakaroon ka ng {resultText}',
  close: 'Isara',
  compareVehicles: 'Paghambingin ang mga Sasakyan',
  'compareVehicles.carMake': 'Tatak ng Kotse',
  'compareVehicles.carModel': 'Modelo ng Kotse',
  'compareVehicles.disclaimer': 'Hindi lahat ng tatak/modelo ay available.',
  'compareVehicles.fuelType': 'Uri ng Panggatong',
  'compareVehicles.pickTwo':
    'Pumili ng kahit 2 sasakyan para simulan ang paghahambing',
  'compareVehicles.selectFuel': 'Pumili ng Uri ng Panggatong',
  'compareVehicles.selectMake': 'Pumili ng Tatak',
  'compareVehicles.selectModel': 'Pumili ng Modelo',
  'compareVehicles.subTitle': 'Tingnan ang Lahat ng Sasakyan >',
  contact: 'Makipag-ugnayan',
  ContactInformation: 'Impormasyon sa Pakikipag-ugnayan',
  conventionalVehicleEfficiency: 'Kahusayan ng Konbensyonal na Sasakyan (mpg)',
  conventionalVehicleEfficiencyTooltip:
    'Para kalkulahin ang mga posibleng matitipid, ilagay ang milya kada galon (MPG) ng sasakyang de-gasolina na gusto mong palitan ng all-electric o Plug-In Hybrid EV.',
  costOfPublicCharging: 'Gastos ng Pampublikong Pagsingil',
  costOfPublicChargingTooltip:
    'Tinatantya namin ang halaga ng mga bayad na pampublikong charging station, ngunit maaari mong i-edit ang filter na ito kung alam mo ang lokal na halaga ng pag-charge sa iyo.',
  CountiesCovered: 'Mga Sakop na Kondado',
  currency: '$',
  currentPricingPlan: 'KASALUKUYANG PLANO NG PAGPEPRESYO',
  dealers: 'Mga Dealer',
  'dealers.allBrands': 'Lahat ng Brand',
  'dealers.allDealers': 'Lahat ng Dealer',
  'dealers.brands': 'Mga Tatak',
  'dealers.contact': 'KONTAKIN',
  'dealers.findDealers': 'Maghanap ng mga Dealer',
  'dealers.website': 'WEBSITE',
  description: 'Paglalarawan',
  DETACHED_GARAGE: 'Hiwalay na Garahe',
  detailedCalculations: 'Mga Detalye',
  driveEVOrPHEV:
    'Magmaneho ng de-kuryenteng sasakyan (all-electric o plug-in hybrid)',
  DRIVEWAY: 'Wala sa Garahe',
  DRParagraph1:
    'Ang karaniwang plano ng pagpepresyo ng DR ay batay sa dami ng kuryenteng ginagamit mo, hindi sa kung kailan mo ito ginagamit. Kung mas kaunti ang kuryenteng ginagamit mo, mas kaunti ang babayaran mo – anumang oras, araw man o gabi.',
  DRParagraph2:
    'Ang planong ito ay maaaring maging angkop para sa mga sambahayang hindi gaanong gumagamit ng pera at sa mga mas gustong magtipid nang hindi iniisip ang oras ng araw.',
  egbBringCharger: 'Gagamitin ko ang sarili kong Level 2 charger.',
  egbNeedCharger: 'Kailangan ko ng Level 2 charger',
  egbOurPrograms:
    'Mayroon kaming mga programa na nagpapadali sa pag-charge sa bahay. Kung kailangan mo ng Level 2 charger, maaaring angkop para sa iyo ang aming EV Accelerate At Home program.',
  electricians: 'Mga Elektrisyan',
  'electricians.commercial': 'Komersyal',
  'electricians.fastEfficient':
    '{title} Ang aming mga timeline ng pag-install ay ligtas at pinabilis upang matulungan kang makapagsimula nang mas maaga.',
  'electricians.industrial': 'Industriyal',
  'electricians.map.caption':
    'Isa ka bang sertipikadong installer ng EV charging station sa lugar ng San Diego? Mangyaring makipag-ugnayan kay {email} upang maisaalang-alang para maisama sa aming database ng mga sertipikadong electrician. Ang mga electrician na nakalista sa site na ito ay hindi ineendorso, inisponsoran o inuupahan ng SDG&E.',
  'electricians.map.header': 'Mga Benepisyo ng Aming Mga Ginustong Kasosyo',
  'electricians.map.personalizedExperience':
    '{title} Matutulungan ka ng aming mga EV Specialist na gabayan sa buong proseso.',
  'electricians.map.value':
    '{title} Nag-aalok kami ng mga kompetitibong presyo sa pag-install.',
  'electricians.residential': 'Residential',
  'electricians.searchElectricians':
    'Maghanap ng mga Kwalipikadong Elektrisyan',
  'electricians.subtitle':
    'Ilagay ang iyong zip code upang makahanap ng mga sertipikadong electrician sa iyong lugar. I-click ang bawat resulta upang makita ang lokasyon at impormasyon sa pakikipag-ugnayan.',
  'electricians.title': 'Mga Sertipikadong Elektrisyan',
  'electricians.type': 'Uri ng Elektrisyan',
  'electricians.worldClass':
    '{title} Nakikipagsosyo kami sa mga bihasang elektrisyan na nasuri upang matiyak ang ligtas at propesyonal na pag-install.',
  electricity: 'Elektrisidad',
  electricPortion: 'Bahaging Elektrisidad',
  electricVehicles: 'Mga Sasakyang De-kuryente',
  emissions: 'Mga Emisyon',
  'Energy Information Administration': 'Pangasiwaan ng Impormasyon sa Enerhiya',
  estimatedDIYCost: 'Tinatayang karaniwang gastos sa DIY:',
  'ev.avg.range': 'Karaniwang Saklaw ng Elektrisidad',
  'ev.carDetails.batterySizeTooltip':
    'Ang isang kilowatt-hour (kWh) ay sapat na enerhiya upang magmaneho ng 1 hanggang 4 na milya, depende sa sasakyan. Ang isang karaniwang baterya ng laptop ay maaaring maglaman ng wala pang 0.1 kWh.',
  'ev.cardetails.calc.arborDayFoundation': 'Pundasyon ng Arbor Day',
  'ev.carDetails.calc.charging': 'Nagcha-charge',
  'ev.cardetails.calc.chargingRate': 'Rate ng Pag-charge',
  'ev.carDetails.calc.chargingRate': 'Rate ng Pag-charge',
  'ev.carDetails.calc.DCFC': 'Mabilis na Pag-charge ng DC (DCFC) Rate',
  'ev.cardetails.calc.dcRate': 'Mabilis na Pag-charge ng DC (DCFC) Rate',
  'ev.cardetails.calc.description': 'Paglalarawan',
  'ev.carDetails.calc.description': 'Paglalarawan',
  'ev.cardetails.calc.EIA':
    'Pangasiwaan ng Impormasyon sa Enerhiya ng Estados Unidos',
  'ev.cardetails.calc.electricEmissions': 'Mga Emisyon ng Elektrisidad sa Lbs',
  'ev.cardetails.calc.electricEmissionsLbsMwh':
    'Mga Emisyon ng Elektrisidad sa Lbs/MWh',
  'ev.cardetails.calc.electricEmissionsLbsMwhMetric':
    'Mga Emisyon ng Elektrisidad sa Kg/MWh',
  'ev.cardetails.calc.electricEmissionsMetric':
    'Mga Emisyon ng Elektrisidad sa kg',
  'ev.cardetails.calc.electricityEmissions':
    'Mga Emisyon ng Elektrisidad sa CO2 lbs/MWh',
  'ev.cardetails.calc.electricityEmissionsMetric':
    'Mga Emisyon ng Elektrisidad sa CO2 kg/MWh',
  'ev.carDetails.calc.electricityEmissionsMetric':
    'Mga Emisyon ng Elektrisidad sa CO2 kg/MWh',
  'ev.carDetails.calc.emissions': 'Mga Emisyon',
  'ev.cardetails.calc.emissionsPerTree': 'Mga Emisyon na Natipid sa Bawat Puno',
  'ev.cardetails.calc.emissionsReductions': 'Mga Pagbawas ng Emisyon',
  'ev.cardetails.calc.emissionsReudctions': 'Mga Pagbawas ng Emisyon',
  'ev.cardetails.calc.EPA': 'Rating ng Kahusayan ng EPA',
  'ev.cardetails.calc.EPAMetric': 'Rating ng Kahusayan ng NRC',
  'ev.carDetails.calc.ev.cardetails.calc.electricityEmissions':
    'Mga Emisyon ng Elektrisidad sa CO2 lbs/MWh',
  'ev.carDetails.calc.fuel': 'Panggatong',
  'ev.cardetails.calc.FuelConsumptionCa':
    'Gabay sa Pagkonsumo ng Panggatong sa Canada',
  'ev.cardetails.calc.gallonsSaved': 'Mga Galon na Na-save',
  'ev.cardetails.calc.gallonsSavedFormula':
    'Mga galon na ginagamit ng Katumbas na Sasakyang Pang-gas - Mga galon na ginagamit ng EV',
  'ev.cardetails.calc.gallonsUsed': 'Mga Galon na Ginamit',
  'ev.cardetails.calc.gallonsUsedFormula':
    'Milya na dinala * (1 - Bahagi ng Pagmamaneho gamit ang Elektrisidad) / MPG',
  'ev.cardetails.calc.gasolineEmissions':
    'Mga Emisyon ng Gasolina sa Lbs kada Galon',
  'ev.cardetails.calc.gasolineEmissionskg': 'Mga Emisyon ng Gasolina sa Kg',
  'ev.cardetails.calc.gasolineEmissionsLbs': 'Mga Emisyon ng Gasolina sa Lbs',
  'ev.cardetails.calc.gasolineEmissionsMetric':
    'Mga Emisyon ng Gasolina sa Kg kada Litro',
  'ev.cardetails.calc.gasolineEmissionsYr':
    'Mga Emisyon ng Gasolina sa lbs ng CO2/taon',
  'ev.cardetails.calc.gasolineEmissionsYrMetric':
    'Mga Emisyon ng Gasolina sa kg ng CO2/taon',
  'ev.cardetails.calc.kgCo2PerYr': 'kg ng CO2 bawat taon',
  'ev.cardetails.calc.kmDrivenPerYr': 'Kilometrong Dinadala Bawat Taon',
  'ev.carDetails.calc.kmDrivenPerYr': 'Kilometrong Dinadala Bawat Taon',
  'ev.carDetails.calc.kwPerKm': 'kWh bawat 100 km',
  'ev.carDetails.calc.kwPerMile': 'kWh bawat 100 milya',
  'ev.cardetails.calc.lbsCo2PerYr': 'libra ng CO2 bawat taon',
  'ev.cardetails.calc.litersSaved': 'Mga Litrong Na-save',
  'ev.cardetails.calc.litersSavedFormula':
    'Mga litrong ginagamit ng Katumbas na Sasakyang Pang-gas - Mga litrong ginagamit ng EV',
  'ev.cardetails.calc.litersUsed': 'Mga Litrong Ginamit',
  'ev.cardetails.calc.litersUsedFormula':
    'Kilometrong dinadala * (1 - Bahagi ng Pagmamanehong De-kuryente) * L/100 km',
  'ev.cardetails.calc.lPer100Km': 'L/100 kilometro',
  'ev.cardetails.calc.lPerKm': 'Litro Bawat 100 Kilometro',
  'ev.cardetails.calc.lpkm': 'litro/kilometro',
  'ev.cardetails.calc.lvl2FullCharge':
    'Oras para Puno ang Karga para sa Level 2',
  'ev.cardetails.calc.lvlTwoChargingRate': 'Antas 2 na Bilis ng Pag-charge',
  'ev.cardetails.calc.maxACIntake': 'Pinakamataas na AC Intake ng Sasakyan',
  'ev.carDetails.calc.milesDriven': 'Milya na Dinala Bawat Taon',
  'ev.cardetails.calc.milesDrivenPerYr': 'Milya na dinala kada taon',
  'ev.cardetails.calc.milesPerGallon': 'Milya Bawat Galon (MPG)',
  'ev.carDetails.calc.milesPerGallonBasic': 'Milya Bawat Galon',
  'ev.cardetails.calc.minOflvl2AC':
    'Minimum na Antas 2 na Rate ng Pag-charge at Pinakamataas na AC Intake ng Sasakyan',
  'ev.cardetails.calc.mpg': 'milya/gal',
  'ev.cardetails.calc.nationalAverageElectricityEmissions':
    'Pambansang Karaniwang Emisyon ng Kuryente',
  'ev.cardetails.calc.portionElectric':
    'Bahagi ng Pagmamaneho gamit ang Elektrisidad',
  'ev.cardetails.calc.portionElectricSource':
    'Input ng gumagamit. Para sa isang hybrid na sasakyan, tinatantya ang bahagi ng milyang nilakbay gamit ang de-kuryenteng baterya sa halip na gasolina.',
  'ev.cardetails.calc.source': 'Pinagmulan',
  'ev.carDetails.calc.source': 'Pinagmulan',
  'ev.cardetails.calc.userInput': 'Input ng Gumagamit',
  'ev.cardetails.calc.vehicleBatteryCapacity':
    'Kapasidad ng Baterya ng Sasakyan',
  'ev.carDetails.compareText':
    'Pinili namin ang {gasVehicle} batay sa kalapitan nito sa {vehicle} batay sa tatak, laki, at presyo.',
  'ev.cardetails.electricRange':
    'Upang maisaalang-alang ang pagkasira ng baterya, ang saklaw na sinipi rito ay isang pagtatantya batay sa edad ng sasakyan at normal na mga gawi sa pagmamaneho/pag-charge.',
  'ev.carDetails.fastChargingTooltip': 'Mabilis na Bilis ng Charger ng DC:',
  'ev.carDetails.gasolineSaved': 'Natipid na Gasolina',
  'ev.carDetails.kilometerBatterySizeTooltip':
    'Ang isang kilowatt-hour (kWh) ay sapat na enerhiya upang magmaneho ng 1 hanggang 4 na milya, depende sa sasakyan. Ang isang karaniwang baterya ng laptop ay maaaring maglaman ng wala pang 0.1 kWh.',
  'ev.carDetails.kilometerUsedBatterySizeTooltip':
    'Ang isang kilowatt-hour (kWh) ay sapat na enerhiya upang magmaneho ng 1 hanggang 4 na kilometro, depende sa sasakyan. Upang isaalang-alang ang pagkasira ng baterya para sa isang segunda-manong EV, ang laki ng baterya na binanggit dito ay isang pagtatantya batay sa edad ng sasakyan at normal na mga pattern ng pagmamaneho/pag-charge.',
  'ev.carDetails.levelTwoChargerSpeedTooltip':
    'Kapag naka-charge gamit ang pampubliko o pribadong Level 2 charger na kayang suportahan ang maximum on-board charge rate ng sasakyang ito. Tandaan na ang programang rebate ng residential ng Consumers Energy ay may pinakamahusay na power rating na hindi hihigit sa 240V/40A (9.6 KW) na mga circuit para sa mga residential charging installation.',
  'ev.carDetails.mobile':
    'Para sa karagdagang detalye kabilang ang mga tsart at kalkulasyon na {amp}, pakitingnan ang pahinang ito sa desktop.',
  'ev.carDetails.treesPlanted': 'Mga Puno na Itinanim',
  'ev.carDetails.usedBatterySizeTooltip':
    'Ang isang kilowatt-hour (kWh) ay sapat na enerhiya upang magmaneho ng 1 hanggang 4 na milya, depende sa sasakyan. Upang isaalang-alang ang pagkasira ng baterya para sa isang segunda-manong EV, ang laki ng baterya na binanggit dito ay isang pagtatantya batay sa edad ng sasakyan at normal na mga pattern ng pagmamaneho/pag-charge.',
  'ev.carDetails.view': 'Tingnan ang mga detalye ng sasakyan',
  'ev.cash': 'Pera',
  'ev.chargingStations.body':
    'Mas madali na ngayon kaysa dati ang mag-charge habang naglalakbay. Ilagay ang iyong lokasyon para makita ng {lineBreak} ang lahat ng charging station na malapit sa iyo.',
  'ev.compareGasVehicle':
    'Ihambing ang {car} sa isang katulad na sasakyang de-gasolina, ang {gasCar}',
  'ev.compareOtherVehicles': 'Ihambing ang Ibang mga Sasakyan',
  'ev.costOfPublicCharing': 'Tinatayang gastos sa pampublikong pagsingil',
  'ev.dealers.body':
    'Tuklasin ang mga dealer ng electric vehicle sa inyong lugar, at i-click ang bawat isa para makita ang lokasyon at impormasyon sa pakikipag-ugnayan.',
  'ev.electricityRateCalc':
    'Ang singil sa kuryente ay kinakalkula bilang isang pinaghalong singil batay sa karaniwang konsumo ng sambahayan na 700 kWh. Para sa karagdagang impormasyon, paki-click ang {website}',
  'ev.electricPortion': 'Bahagi ng Electric Miles',
  'ev.electricPortionTooltip':
    'Tantyahin kung ilang porsyento ng iyong milya sa pagmamaneho ang magiging ganap na de-kuryente. Kung magre-charge ka araw-araw at magmaneho nang mas kaunti bawat araw kaysa sa nais mong all-electric range ng EV, ang iyong porsyento ay malapit sa 100%. Kung hindi ka sigurado sa porsyento ng iyong electric portion, piliin ang 50%.',
  'ev.incentives.title':
    'Hanggang {savings} sa mga kredito sa buwis at mga rebate ang posibleng makukuha sa {lineBreak} para sa {car}',
  'ev.incentives.title.simple': 'Mga Magagamit na Insentibo at Rebate',
  'ev.interestRate': 'Rate ng Interes',
  'ev.jumbotron.findADealer': 'Maghanap ng Dealer',
  'ev.jumbotron.viewAllCars': 'Tingnan ang lahat ng mga kotse',
  'ev.kilometersDrivenAnnually': 'Kilometrong Dinadala Bawat Taon',
  'ev.lease': 'Pag-upa',
  'ev.loan': 'Pautang',
  'ev.matchScore.adjustment': 'Pagsasaayos',
  'ev.matchScore.budget': 'Badyet',
  'ev.matchScore.charging': 'Nagcha-charge',
  'ev.matchScore.maxScore': 'Pinakamataas na Iskor',
  'ev.matchScore.popover':
    'Ang iyong Match Score ay batay sa iyong mga napiling kagustuhan.',
  'ev.matchScore.range': 'Saklaw',
  'ev.matchScore.seats': 'Mga Upuan',
  'ev.matchScore.title': 'Iskor ng Laban',
  'ev.matchScore.totalScore': 'Kabuuang Iskor',
  'ev.matchScore.yourScore': 'Ang Iyong Iskor',
  'ev.milesDrivenAnnually': 'Milya na Dinala Bawat Taon',
  'ev.planningRoute.body':
    'Mas madali na ngayon kaysa dati ang mag-charge habang naglalakbay. Ilagay ang iyong destinasyon para makita ang lahat ng charging station na madadaanan mo.',
  'ev.public': 'Pampubliko',
  'ev.publicPrivateCharging': 'Paghaluin ang pampubliko/pribadong pag-charge',
  'ev.purchaseMethod': 'Paraan ng Pagbili',
  'ev.purchaseMethodToolTip':
    'Sa isang lease, kailangan mong ibalik ang kotse pagkatapos ng panahon ng lease. Sa kaso ng loan financing, mananatili sa iyo ang kotse pagkatapos mabayaran ang utang.',
  'ev.reviews': 'Mga review mula sa buong web',
  'ev.showSources.assumption': 'Pagpapalagay:',
  'ev.showSources.averageInsurancePerYear': 'Karaniwang Seguro kada Taon',
  'ev.showSources.blendedMaintenanceCostPerKilometer':
    'Pinagsamang gastos sa pagpapanatili bawat kilometro',
  'ev.showSources.blendedMaintenanceCostPerKilometerSource':
    'Bahagi ng Electric Driving na inilalapat sa Maintenance kada kilometro para sa gasolina at para sa kuryente',
  'ev.showSources.blendedMaintenanceCostPerMile':
    'Pinagsamang gastos sa pagpapanatili bawat milya',
  'ev.showSources.blendedMaintenanceCostPerMileSource':
    'Bahagi ng Pagmamanehong De-kuryente na inilalapat sa Pagpapanatili bawat milya para sa gasolina at para sa kuryente',
  'ev.showSources.capitalizedCost': 'Kapitalisadong Gastos',
  'ev.showSources.capitalizedCostSource':
    'MSRP - Paunang Bayad - Mga Insentibo na Naka-kapital',
  'ev.showSources.capitalizedIncentives': 'Mga Kapitalisadong Insentibo',
  'ev.showSources.capitalizedIncentivesSource':
    'Mga insentibo na ikinapital sa loob ng kontrata ng pag-upa',
  'ev.showSources.cashFormula':
    'MSRP ng Sasakyan * (1 + Buwis sa Pagbebenta) - Mga Insentibo - Halaga ng Muling Pagbebenta',
  'ev.showSources.dollarPerKilometerDriven': '$/100 km ang biyahe',
  'ev.showSources.dollarPerKilometerDrivenPublicCharging':
    '(Tinatayang Gastos ng Pampublikong Pag-charge * Halong Pampublikong/Pribadong Pag-charge + Bayad sa Kuryente * (1 - Halong Pampublikong/Pribadong Pag-charge)) * KWh ng Sasakyan bawat 100 km',
  'ev.showSources.dollarPerKilometerDrivenSource':
    'Gastos sa Elektrisidad * kWh ng Sasakyan bawat 100 km',
  'ev.showSources.dollarPerMileDriven': '$/100 milya ang biyahe',
  'ev.showSources.dollarPerMileDrivenPublicCharging':
    '(Tinatayang Gastos ng Pampublikong Pag-charge * Halong Pampublikong/Pribadong Pag-charge + Bayad sa Kuryente * (1 - Halong Pampublikong/Pribadong Pag-charge)) * KWh ng Sasakyan bawat 100 milya',
  'ev.showSources.dollarPerMileDrivenSource':
    'Gastos sa Elektrisidad * kWh ng Sasakyan kada 100 mi',
  'ev.showSources.electricityRate':
    'Ang singil sa kuryente ay batay sa {website}',
  'ev.showSources.EPAEfficiency': 'Rating ng Kahusayan ng EPA',
  'ev.showSources.estimatedCostOfPublicCharging':
    'Tinatayang Gastos ng Pampublikong Pagsingil',
  'ev.showSources.firstLeasePayment': 'Unang Bayad sa Pag-upa',
  'ev.showSources.firstLeasePaymentSource':
    'Paunang Bayad + Buwanang Bayad sa Pag-upa',
  'ev.showSources.gasolineCost': 'Gastos ng Gasolina',
  'ev.showSources.insurancePerYear': 'Seguro kada Taon',
  'ev.showSources.insurancePerYearSource':
    'Pag-ekstrapolasyon ng karaniwang gastos sa seguro sa {state}, na hinihimok ng MSRP ng sasakyan kaugnay ng karaniwang MSRP na {msrp}',
  'ev.showSources.insuranceSource': 'Karaniwang Gastos sa Seguro',
  'ev.showSources.kilometerVehicleKWh': 'kWh ng sasakyan kada 100 km',
  'ev.showSources.leaseForumla':
    'Unang Bayad sa Pag-upa + (Mga Buwan ng Pagmamay-ari - 1) * (Buwanang Bayad sa Pag-upa) - Mga Insentibo sa Pag-upa na Hindi Naka-kapital',
  'ev.showSources.lifetimeKilometers': 'Mga Kilometro sa Habambuhay',
  'ev.showSources.lifetimeMiles': 'Mga Milya Panghabambuhay',
  'ev.showSources.loanAmount': 'Halaga ng Pautang',
  'ev.showSources.loanFormula':
    'MSRP * (1 + Buwis sa Pagbebenta) - Paunang Bayad',
  'ev.showSources.maintenanceCostReduction':
    'Pagbabawas ng Gastos sa Pagpapanatili ng EV',
  'ev.showSources.maintenanceCostReductionSource': '{website}',
  'ev.showSources.maintenancePerKilometer':
    'Pagpapanatili bawat kilometro para sa gasolina',
  'ev.showSources.maintenancePerKilometerElectricity':
    'Pagpapanatili bawat kilometro para sa kuryente',
  'ev.showSources.maintenancePerKilometerElectricitySource':
    'Pagpapanatili bawat kilometro para sa gasolina * Salik sa Pagbawas ng Pagpapanatili ng EV',
  'ev.showSources.maintenancePerMile':
    'Pagpapanatili kada milya para sa gasolina',
  'ev.showSources.maintenancePerMileElectricity':
    'Pagpapanatili kada milya para sa kuryente',
  'ev.showSources.maintenancePerMileElectricitySource':
    'Pagpapanatili bawat milya para sa gasolina * Salik sa Pagbawas ng Pagpapanatili ng EV',
  'ev.showSources.maintenancePerMileSource':
    'Pag-ekstrapolasyon ng karaniwang gastos sa pagpapanatili na {avgMaintenanceCost}, na hinihimok ng MSRP ng sasakyan kaugnay ng karaniwang MSRP na {averageMSRP}',
  'ev.showSources.mixPublicPrivateCharging':
    'Paghaluin ang Pampubliko/Pribadong Pag-charge',
  'ev.showSources.moneyFactor': 'Salik ng Pera',
  'ev.showSources.moneyFactorSource':
    'Katumbas ng input ng user na {interestRateAsBasisPoints}',
  'ev.showSources.monthlyDepreciationCost': 'Buwanang Gastos sa Depreciation',
  'ev.showSources.monthlyDepreciationCostSource':
    '(Kapitalisadong Gastos - Halaga ng Muling Pag-iipon) / Mga Buwan ng Pagmamay-ari',
  'ev.showSources.monthlyFinancingCost': 'Buwanang Gastos sa Pagpopondo',
  'ev.showSources.monthlyFinancingCostSource':
    '(Kapital na Gastos + Halaga ng Muling Pagbebenta) * Salik ng Pera',
  'ev.showSources.monthlyLeasePayment': 'Buwanang Bayad sa Pag-upa',
  'ev.showSources.monthlyLeasePaymentSource':
    '(Buwanang Gastos sa Depreciation + Buwanang Gastos sa Financing) * (1 + Buwis sa Pagbebenta)',
  'ev.showSources.monthlyPayments': 'Buwanang Bayad',
  'ev.showSources.monthlyPaymentsSource':
    'Tungkuling Pinansyal ng Halaga ng Pautang, Rate ng Interes, at Buwan ng Pagmamay-ari',
  'ev.showSources.monthsOfOwnership': 'Mga Buwan ng Pagmamay-ari',
  'ev.showSources.nonCapLeaseIncentives':
    'Mga Insentibo sa Pag-upa na Hindi Naka-kapitalisa',
  'ev.showSources.nonCapLeaseIncentivesSource':
    'Mga insentibo na hindi nakuha sa capitalized lease cost',
  'ev.showSources.portionElectricSource':
    'Input ng gumagamit. Para sa isang hybrid na sasakyan, tinatantya ang bahagi ng milyang nilakbay gamit ang de-kuryenteng baterya sa halip na gasolina.',
  'ev.showSources.portionElectricSourceKilometer':
    'Input ng gumagamit. Para sa isang hybrid na sasakyan, tinatantya ang bahagi ng kilometrong minamaneho gamit ang de-kuryenteng baterya sa halip na gasolina.',
  'ev.showSources.resaleValue': 'Halaga ng Muling Pagbebenta',
  'ev.showSources.resaleValueSource':
    '{carName}: e^(ln({resaleFactor})/36000*{lifetimeMiles})*MSRP',
  'ev.showSources.totalElectricityCost': 'Kabuuang Gastos sa Elektrisidad',
  'ev.showSources.totalElectricityCostSource':
    '$/100 milyang biyahe * Panghabambuhay na Milya * {portionEVDriving}/ 100',
  'ev.showSources.totalGasolineCost': 'Kabuuang Gastos sa Gasolina',
  'ev.showSources.totalGasolineCostSource':
    'Gastos ng Gasolina * Panghabambuhay na Milya * {portionEVDriving}/ MPG',
  'ev.showSources.totalInsuranceCost': 'Kabuuang Gastos ng Seguro',
  'ev.showSources.totalInsuranceCostSource':
    'Gastos ng seguro bawat taon * Mga Taon ng Pagmamay-ari',
  'ev.showSources.totalKilometerElectricityCostSource':
    '$/100 km na dinala * Panghabambuhay na Kilometro * {portionEVDriving}/ 100',
  'ev.showSources.totalKilometerGasolineCostSource':
    'Gastos sa Gasolina * Panghabambuhay na Kilometro * {portionEVDriving}/ lPerKm',
  'ev.showSources.totalKilometerMaintenanceCostSource':
    'Gastos sa pagpapanatili bawat kilometro * Panghabambuhay na Kilometro',
  'ev.showSources.totalLoanFormula':
    'Paunang Bayad + Kabuuang Buwanang Bayad - Mga Insentibo - Halaga ng Muling Pagbebenta',
  'ev.showSources.totalMaintenanceCost': 'Kabuuang Gastos sa Pagpapanatili',
  'ev.showSources.totalMaintenanceCostSource':
    'Gastos sa pagpapanatili bawat milya * Panghabambuhay na Milya',
  'ev.showSources.totalMonthlyPayments': 'Kabuuang Buwanang Bayad',
  'ev.showSources.totalMonthlyPaymentsSource':
    'Buwanang Bayad * Mga Buwan ng Pagmamay-ari',
  'ev.showSources.totalVehicleCost': 'Kabuuang Gastos ng Sasakyan',
  'ev.showSources.vehicleKWh': 'kWh ng sasakyan kada 100 mi',
  'ev.showSources.vehiclelPerKm': 'LperKm ng Sasakyan (litro bawat kilometro)',
  'ev.showSources.vehicleMPG': 'MPG ng Sasakyan (milya kada galon)',
  'ev.showSources.yearsOfOwnership': 'Mga Taon ng Pagmamay-ari',
  'ev.used.electricRange': 'Karaniwang Saklaw ng Elektrisidad',
  'ev.used.yearRange': 'Saklaw ng Taon',
  'ev.usedCarTitle': 'Ginamit na {car}',
  'ev.yearsOwnership': 'Mga Taon ng Pagmamay-ari/Pag-upa',
  'evCard.electricRange': 'Saklaw ng Elektrisidad',
  'evCard.matchScore': 'ISKOR NG LARO',
  'evCard.seeDetails': 'Tingnan ang mga Detalye',
  'evCard.seeElectricVehicle': 'TINGNAN ANG SASAKYAN NA DE-KURYENTE',
  'evCard.totalRange': 'Kabuuang Saklaw',
  'eventCard.hostedBy': 'Hino-host ni',
  'eventCard.inPerson': 'Kaganapan nang Personal',
  'eventCard.inPersonAndVirtual': 'Nang Personal + Virtual na Kaganapan',
  'eventCard.learnMore': 'Matuto Nang Higit Pa',
  'eventCard.virtualEvent': 'Virtual na Kaganapan',
  'eventCatalog.noEvents':
    'Walang matagpuang kaganapan na tumutugma sa iyong kasalukuyang pamantayan sa paghahanap. Subukang baguhin ang iyong pamantayan sa paghahanap',
  'eventCatalog.noMatch': 'Wala kaming nakitang anumang tugma.',
  events: 'Mga Kaganapan',
  'events.allLocations': 'Lahat ng Lokasyon',
  'events.autoshow': 'Autoshow',
  'events.both': 'Nang Personal at Virtual',
  'events.conference': 'Kumperensya',
  'events.distance': 'Distansya',
  'events.educationEvent': 'Kaganapan sa Edukasyon',
  'events.inPerson': 'Nang Personal',
  'events.inPersonOrVirtual': 'Nang Personal o Virtual',
  'events.nationwide': 'Sa buong bansa',
  'events.nationWide': 'Sa buong bansa',
  'events.rideAndDrive': 'Sumakay at Magmaneho',
  'events.subHeader':
    'Masdan, hawakan, at damhin mismo ang isang de-kuryenteng sasakyan sa isang paparating na kaganapan.',
  'events.training': 'Pagsasanay',
  'events.virtual': 'Birtwal',
  'events.webinar': 'Webinar',
  eventsDateRange: 'Saklaw ng Petsa',
  eventsFilters: 'Mga Filter',
  'eventSort.dateLtH': 'Petsa (Maaga muna)',
  evfilter: 'Mga Filter',
  'evfilter.carTitle': 'Kagustuhan sa EV',
  'evfilter.fuel': 'Panggatong',
  'evfilter.fuelTooltip':
    'Ang mga sasakyang puro de-kuryente ay gumagamit lamang ng kuryente. Ang mga plug-in hybrid ay maaaring gumamit ng kuryente at gasolina.',
  'evfilter.type': 'Uri',
  evFuelType: 'Lahat ng Elektrisidad',
  'evs.budgetAfterIncentives': 'Badyet pagkatapos ng mga Insentibo',
  'evs.buttonMatchScoreAndFilters': 'Iskor at mga Filter ng Pagtutugma',
  'evs.chargercard.chargingtime.na': 'NA',
  'evs.chargerCatalog.noChargers': 'Walang nakitang Charger',
  'evs.chargingAvailability': 'Availability ng Pag-charge',
  'evs.disclaimer':
    'Ang mga sasakyang ipinapakita ay maaaring hindi sumasalamin sa aktwal na availability. Hindi kami nag-eendorso o nagrerekomenda ng anumang partikular na tagagawa ng sasakyan o kotse.',
  'evs.graph.compare':
    'Paghambingin ang mga electric car ayon sa saklaw o presyo ng EV. I-hover ang mouse sa EV para sa higit pang detalye.',
  'evs.graph.disclaimer':
    'Ang mga sasakyang ipinapakita ay maaaring hindi sumasalamin sa aktwal na availability. Ang {companyName} ay hindi nag-eendorso o nagrerekomenda ng anumang partikular na tagagawa ng sasakyan o kotse.',
  'evs.graph.mobile':
    'Para makita ang Graph ng Saklaw vs. Gastos, pakitingnan ang pahinang ito sa desktop.',
  'evs.graph.rangeVsCost': 'Saklaw vs. Gastos',
  'evs.graph.tiles': 'Mga Tile ng Sasakyan',
  'evs.graph.title': 'Mga Sasakyang De-kuryente',
  'evs.helpMeChoose': 'Tulungan mo akong pumili',
  'evs.highPower.legend': 'Mga Istasyon ng Mataas na Enerhiya',
  'evs.homeChargingAvailability': 'Availability ng Pag-charge sa Bahay',
  'evs.homeChargingAvailabilityTooltip':
    'Mas maraming sasakyang de-kuryente ang magiging maginhawa para sa iyo kung mabilis kang makakapag-charge sa bahay.',
  'evs.incentivesScoreOptions':
    'Mga Filter ng Pagiging Karapat-dapat sa Insentibo',
  'evs.levelOne': 'Antas 1',
  'evs.levelTwo': 'Antas 2',
  'evs.matchScoreAndFilters': 'Pinuhin ang Iskor at mga Filter ng Pagtutugma',
  'evs.matchScoreOptions': 'Mga Filter',
  'evs.minSeats': 'Pinakamababang Upuan',
  'evs.noCharging': 'Walang Pag-charge',
  'evs.other.legend': 'Iba Pang Uri ng mga Istasyon',
  'evs.public.legend': 'Mga Pampublikong Istasyon',
  'evs.roundTripCommute': 'Karaniwang milya araw-araw',
  'evs.seats': 'mga upuan',
  'evs.slideMilesDrivenDaily': 'Pinakamababang Saklaw',
  'evs.thirdParty':
    '*Ang website na ito ay naglalaman ng mga link papunta sa mga panlabas na website ng ikatlong partido. Hindi ineendorso o tinatanggap ng SDGE ang anumang pananagutan para sa nilalaman o mga produktong ibinebenta sa anumang website ng ikatlong partido. Pakitandaan na maaaring hindi available ang sasakyang ito sa inyong lugar. Makipag-ugnayan sa inyong lokal na dealer upang matiyak ang availability.',
  'evs.welcomeSub':
    'Iayon ang iyong paghahanap upang matuklasan ang mga de-kuryenteng sasakyan na akma sa iyong mga pangangailangan.',
  'evs.welcomeSubMobile':
    'Iayon ang iyong paghahanap upang matuklasan ang mga de-kuryenteng sasakyan na akma sa iyong mga pangangailangan.',
  'evSort.alphabetical': 'Alpabeto',
  'evSort.chargerPower': 'Lakas ng Pag-charge',
  'evSort.electricRange': 'Saklaw ng Elektrisidad',
  'evSort.matchScore': 'Iskor ng laban',
  'evSort.priceHtL': 'Presyo: Mataas hanggang Mababa',
  'evSort.priceLtH': 'Presyo: Mababa hanggang Mataas',
  'evSort.title': 'PAG-URI-URI AYON SA',
  FAQ: 'Mga Madalas Itanong',
  feet: 'mga paa',
  filing_status_tooltip:
    'Ginagamit upang matukoy ang pagiging karapat-dapat sa insentibo.',
  fuel_tooltip: 'Piliin ang lahat ng uri ng katawan ng sasakyan na interesado ka.',
  Finished: 'Tapos na',
  'footer.allRights': 'Nakalaan ang Lahat ng Karapatan.',
  'footer.chargingStations': '{chargingStations}',
  'footer.compareVehicles': '{compareVehicles}',
  'footer.copyright':
    '© 1998-2026 San Diego Gas & Electric Company. Ang mga trademark na ginamit dito ay pag-aari ng kani-kanilang mga may-ari. Lahat ng karapatan ay nakalaan.',
  'footer.disclaimer':
    'Ang {COMPANY_NAME}® Company ay isang subsidiary ng Sempra®. Ang SDG&E® at San Diego Gas & Electric ay mga rehistradong trademark ng San Diego Gas & Electric Company.',
  'footer.electricVehicles': '{electricVehicles}',
  'footer.homeChargers': '{homeChargers}',
  'footer.incentives': '{incentives}',
  'footer.jdpDisclaimer':
    'Ang mga bilang na ipinapakita sa pahinang ito ay mga pagtatantya batay sa datos na ibinigay ng mga ikatlong partido. Ang materyal na ito ay ibinibigay para sa mga layuning pang-impormasyon lamang at hindi dapat umasa para sa payo sa buwis, legal, o pinansyal. Hindi nagbibigay ang J.D. Power® o SDGE ng payo sa buwis, legal o pinansyal. Dapat mong independiyenteng beripikahin ang mga pagtatantya na ibinigay dito bago sumali sa anumang transaksyon.',
  'footer.poweredBy': 'Pinapagana ng Zappyride',
  'footer.ratepayerDisclaimer':
    'Ang mga mensaheng nakapaloob sa site na ito ay pinopondohan ng mga nagbabayad ng singil maliban kung may ibang nabanggit.',
  'footer.zappyDisclaimer':
    'Ang mga bilang na ipinapakita sa pahinang ito ay mga pagtatantya batay sa datos na ibinigay ng mga ikatlong partido. Ang materyal na ito ay ibinibigay para sa mga layuning pang-impormasyon lamang at hindi dapat umasa para sa payo sa buwis, legal, o pinansyal. Hindi nagbibigay ang J.D. Power® o SDGE ng payo sa buwis, legal o pinansyal. Dapat mong independiyenteng beripikahin ang mga pagtatantya na ibinigay dito bago sumali sa anumang transaksyon.',
  'footer.zappyDisclaimer.one':
    'Mga solusyon sa EV © 2026 J.D. Power, ibinigay nang may pahintulot.',
  footerPhrase1: 'Mga Rate at Regulasyon',
  footerPhrase10: 'Kabuuang Singil sa Kuryente',
  footerPhrase11: 'Pagpili ng Kustomer',
  footerPhrase2: 'Kahilingan sa Datos ng Enerhiya',
  footerPhrase3: 'Mga Tuntunin at Kundisyon',
  footerPhrase4: 'Mga Pamantayan ng Pag-uugali ng FERC - Kautusan 717',
  footerPhrase5: 'Mga Pangunahing Proyekto',
  footerPhrase6: 'Serbisyo sa Kustomer',
  footerPhrase7: 'Mga Post ng CPUC',
  footerPhrase8: 'Mga Karera',
  footerPhrase9: 'Sentro ng Pagkapribado',
  forInstallation: 'para sa pag-install',
  forLevelTwoCharger: 'para sa level 2 charger',
  forSeparateMeter: 'para sa hiwalay na metro',
  free: 'Libre',
  ft: 'talampakan',
  galperyear: 'babae/taon',
  garage: 'Garahe',
  gasoline: 'Gasolina',
  gasolinePrice: 'Presyo ng Gasolina',
  gasolinePriceInCentsPerGal_tooltip:
    'Ilagay ang presyo ng gasolina sa inyong lugar. Ang aming default ay batay sa pinakabagong presyo ng gasolina sa inyong rehiyon, na ina-update buwan-buwan.',
  'graph.assumptions': 'Mga Pagpapalagay',
  'graph.cheaper': 'mas mura',
  'graph.costDifferent': 'Bakit magkaiba ang gastos?',
  'graph.costOfOwnership.chart.electricity': 'Elektrisidad',
  'graph.costOfOwnership.chart.gasoline': 'Gasolina',
  'graph.costOfOwnership.chart.insurance': 'Seguro',
  'graph.costOfOwnership.chart.maintenance': 'Pagpapanatili',
  'graph.costOfOwnership.chart.vehicle':
    'Mga Netong Insentibo ng Sasakyan, Muling Pagbebenta',
  'graph.costOfOwnership.description': 'Paglalarawan',
  'graph.costOfOwnership.descriptionRow.electricity': 'Elektrisidad',
  'graph.costOfOwnership.descriptionRow.gasoline': 'Gasolina',
  'graph.costOfOwnership.descriptionRow.insurance': 'Seguro',
  'graph.costOfOwnership.descriptionRow.maintenance': 'Pagpapanatili',
  'graph.costOfOwnership.descriptionRow.vehicle': 'Sasakyan',
  'graph.costOfOwnership.subTitle':
    'Ang {carName} ay {style} {costDeltaText} {costDeltaTextEnding}',
  'graph.costOfOwnership.subTitleThreeCars':
    'Ang {carName} ang pinakamurang ariin sa loob ng {yearsOfOwnership} taon',
  'graph.costOfOwnership.title': 'Gastos ng Pagmamay-ari',
  'graph.costOfOwnership.totalRow': 'Kabuuan',
  'graph.costToBreakdown': 'Gastos sa Pagkasira',
  'graph.costToBreakdown.note':
    'Paalala: Ipinapalagay ng breakeven chart na ang mga sasakyan ay binili nang cash.',
  'graph.costToBreakdown.subTitle':
    'Ihambing ang pinagsama-samang gastos sa buong buhay ng {car1} sa isang {car2}',
  'graph.costToBreakdown.subTitleThreeCars':
    'Paghambingin ang pinagsama-samang gastos sa buong buhay ng {car1}, {car2} at {car3}',
  'graph.costVsRange.afterIncentives':
    'Mula sa {price} pagkatapos ng mga insentibo',
  'graph.costVsRange.electricKilometerRange':
    'Saklaw ng Elektrisidad: {kilometers} kilometro',
  'graph.costVsRange.electricRange': 'Saklaw ng Elektrisidad: {miles} milya',
  'graph.electricRange.assumption': 'Saklaw batay sa mga Pagtatantya ng EPA',
  'graph.electricRange.assumptions': 'Mga Pagpapalagay',
  'graph.electricRange.description': 'Paglalarawan',
  'graph.electricRange.electricity': 'Elektrisidad',
  'graph.electricRange.gasoline': 'Gasolina',
  'graph.electricRange.gasolineRange': 'Saklaw ng Gasolina',
  'graph.electricRange.subTitle':
    'Ang saklaw ng kuryente ng {car} ay {costDeltaText} nang {number} milya',
  'graph.electricRange.subTitleThreeCars':
    'Ang {car} ang may pinakamahabang Saklaw ng Elektrisidad',
  'graph.electricRange.total': 'Kabuuan',
  'graph.fuelRange.chart.chargedHome': 'sinisingil sa bahay',
  'graph.fuelRange.chart.description': 'Paglalarawan',
  'graph.fuelRange.chart.fuelBudget': 'badyet ng gasolina',
  'graph.fuelRange.chart.howFar':
    'Gaano kalayo ang kaya mong imaneho nang {car} gamit ang {budget} na badyet sa gasolina?',
  'graph.fuelRange.chart.kilometers': 'kilometro',
  'graph.fuelRange.chart.miles': 'milya',
  'graph.fuelRange.chart.network': 'sa Plug-In Everywhere network',
  'graph.fuelRange.chart.rangeOn': 'Saklaw naka-on',
  'graph.fuelRange.chart.similarGas':
    'isang katulad na Sasakyang Pang-gasolina',
  'graph.fuelRange.chart.unlimited': 'Walang limitasyon',
  'graph.graphValues': 'mga halaga ng grap',
  'graph.hide': 'Itago',
  'graph.monthlyCostToFill.subTitle':
    'Ang {carName} ay {style} {costDeltaText} na pupunan buwan-buwan',
  'graph.monthlyCostToFill.subTitleThreeCars':
    'Ang {carName} ang pinakamurang punuin buwan-buwan',
  'graph.monthlyCostToFill.title': 'Gastos sa Pagpuno Buwan-buwan',
  'graph.moreExpensive': 'mas mahal',
  'graph.show': 'Ipakita',
  'graph.showCostBreakdown': 'Ipakita ang Pagbabahagi ng Gastos',
  'graph.similarGasVehicle': 'Katulad na Sasakyang Pang-gasolina',
  'graph.speedOfCharge.fastChargerTitle':
    'Halaga ng Charge Bawat 30 Minuto ng Mabilis na Pag-charge',
  'graph.speedOfCharge.fastChargingSpeed': 'Mabilis na Bilis ng Pag-charge',
  'graph.speedOfCharge.kilometersLevelTwoChargerThreeCars':
    'nagcha-charge ng pinakamaraming kilometro kada oras gamit ang level 2 charger',
  'graph.speedOfCharge.kilometersThirtyFastChargeThreeCars':
    'nagcha-charge ng pinakamaraming kilometro kada 30 minuto ng fast charging',
  'graph.speedOfCharge.kmLevelTwoCharger':
    'kilometro kada oras gamit ang level 2 charger',
  'graph.speedOfCharge.kmThirtyFastCharge':
    'kilometro bawat 30 minuto ng mabilis na pag-charge',
  'graph.speedOfCharge.levelTwoChargingSpeed': 'Antas 2 Bilis ng Charger',
  'graph.speedOfCharge.mphLevelTwoCharger':
    'milya kada oras gamit ang level 2 charger',
  'graph.speedOfCharge.mphLevelTwoChargerThreeCars':
    'nagcha-charge ng pinakamaraming milya kada oras gamit ang level 2 charger',
  'graph.speedOfCharge.mphLevelTwoChargerTitle':
    'Halaga ng Singil Bawat Oras ng Level 2 Charging',
  'graph.speedOfCharge.subTitle':
    'Ang mga singil na {car} ay {number} {costDeltaText} {subTitleText}',
  'graph.speedOfCharge.subTitleThreeCars': 'Ang {car} {subTitleText}',
  'graph.speedOfCharge.thirtyFastCharge':
    'milya kada 30 minuto ng mabilis na pag-charge',
  'graph.speedOfCharge.thirtyFastChargeThreeCars':
    'nagcha-charge ng pinakamaraming milya kada 30 minuto ng fast charging',
  'graph.title.costAnalysis': 'Pagsusuri ng Gastos',
  'graph.title.electricRange': 'Saklaw ng Elektrisidad',
  'graph.title.miles': 'Milya',
  'graph.title.speedOfCharge': 'Bilis ng Pag-charge',
  'graph.title.totalRange': 'Kabuuang Saklaw',
  'graph.toOwnOver': 'magmay-ari',
  'graph.year': 'Taon',
  'graph.years': 'Mga Taon',
  'graph.yourEV': 'Ang Iyong Pinili na EV',
  hcaCarCondition: 'KONDISYON NG KOTSE',
  hcaCarMake: 'Tatak ng Kotse',
  hcaCarModel: 'Modelo ng Kotse',
  hcaChargerLocation: 'Lokasyon ng Charger',
  hcaCurrentElectricRate: 'Kasalukuyang Singil sa Kuryente',
  hcaCurrentMonthlyBill: 'Kasalukuyang Buwanang Singil',
  hcaDistanceSliderLabel: 'Distansya: Panel sa Lokasyon ng Pag-charge',
  hcaDistanceSliderLabelToolTip:
    'Isaalang-alang na ang mga electrical circuit ay karaniwang hindi tumatakbo sa isang tuwid na linya sa pagitan ng panel at lokasyon ng pag-charge dahil sa mga dingding, sahig, o espasyo sa labas sa pagitan.',
  hcaElectricPanelLocation: 'Lokasyon ng Panel ng Elektrisidad',
  hcaIncludedEnergyCosts: 'KASAMA ANG MGA GASTOS SA ENERHIYA',
  hcaNewestModels: 'Pinakabagong mga Modelo',
  hcaOlderModels: 'Mga Lumang Modelo',
  hcaPanelLocationRoomType: 'Lokasyon ng Panel Uri ng Kwarto',
  hcaPortionPublicCharging: 'Bahagi ng Pampublikong Pagsingil',
  hcaPortionPublicChargingTooltip:
    'Halos lahat ng pag-charge ng mga EV driver ay ginagawa sa bahay.',
  hcaPublicChargingCost: 'Gastos sa Pampublikong Pagsingil',
  hcaWhenWillYouCharge: 'Kailan ka magcha-charge?',
  'header.cards.electricians': 'Maghanap ng mga Sertipikadong Elektrisyan',
  'header.cards.home-chargers': 'Mga Charger sa Bahay sa Mamili',
  'header.cards.incentives': 'Mga Insentibo sa Paghahanap',
  'header.cards.rates': 'Tingnan ang Calculator ng Ipon',
  'header.chargingStations': 'Mga Istasyon ng Pag-charge',
  'header.compareVehicles': 'Paghambingin ang mga Sasakyan',
  'header.electricians': 'Mga Elektrisyan',
  'header.electricVehicles': 'Mga Sasakyang De-kuryente',
  'header.electricVehicles.v2': 'Galugarin ang mga EV',
  'header.home': 'Tahanan',
  'header.homeChargers': 'Mga Charger sa Bahay',
  'header.incentives': 'Mga Insentibo',
  'header.newVehicles': 'Galugarin ang mga Opsyon sa Sasakyang De-kuryente',
  'header.promise.cta': 'Magsimula sa mga Insentibo',
  'header.promise.subtitle':
    'Tantyahin at ihambing ang mga gastos, matitipid, insentibo at marami pang iba sa EV.',
  'header.promise.title': 'Sulitin ang iyong EV.',
  'header.rates': 'Kalkulador ng Pagtitipid',
  'header.usedVehicles': 'Galugarin ang mga Opsyon sa Sasakyang De-kuryente',
  here: 'dito',
  high: 'Mataas',
  home: 'Tahanan',
  'home.vehicleCarousel.browseAllEvs': 'I-browse ang Lahat ng EV',
  'home.vehicleCarousel.compareEvs': 'Paghambingin ang mga EV',
  'home.vehicleCarouselSubTitle':
    'Ihambing ang iyong napili sa isang katulad na sasakyang de-gasolina. Makakatipid ka ng pera gamit ang isang EV dahil mas mura itong pagmamay-ari at pagpapanatili kaysa sa isang 100% sasakyang de-gasolina.',
  'home.vehicleCarouselTitle':
    'Mas marami nang sasakyang de-kuryente ngayon kaysa dati. Tuklasin ang sa iyo.',
  homechargerChargerType: 'URI NG CHARGER',
  homechargerEvfilter: 'Mga Pangunahing Filter',
  homeChargers: 'Mga Charger sa Bahay',
  'homeChargers.cable': '{length} talampakan. Kable',
  'homechargers.caption':
    'Ang mga charger sa bahay na nakalista sa site na ito ay hindi gawa o ineendorso ng SDG&E.',
  'homeChargers.cordLength': 'Haba ng Kurdon',
  'homeChargers.cordLengthHtL': 'Haba ng Kurdon: Mataas hanggang Mababa',
  'homeChargers.cordLengthLtH': 'Haba ng Kurdon: Mababa hanggang Mataas',
  'homeChargers.disclaimer':
    'Mga tagagawa ng charger, gusto mo bang maitampok ang iyong charger dito? Makipag-ugnayan kay {email}.',
  'homeChargers.hardwired': 'Naka-hardwire',
  'homeChargers.meterCable': '{length} m na Kable',
  'homeChargers.portable': 'Madadala',
  'homeChargers.price': 'Presyo',
  'homeChargers.selectMake': 'Pumili ng Tatak',
  'homeChargers.selectModel': 'Pumili ng Modelo',
  'homeChargers.socket': 'Socket',
  'homeChargers.socketTooltip':
    'Iba-iba ang mga disenyo ng saksakan ng mga EV charger sa bahay. Ang mga disenyo ng saksakan na ito ay tumutugma sa kung paano umaangkop ang kanilang mga ngipin sa iyong saksakan sa dingding. Kung hindi ka sigurado kung aling saksakan ang pinakamainam para sa iyong bahay o garahe, kumonsulta sa isang sertipikadong elektrisyan.',
  'homeChargers.subText':
    'Piliin ang sasakyan na interesado ka upang makita ang partikular na oras ng pag-charge hanggang sa mapuno ang baterya.',
  'homeChargers.subtitle':
    'Maghanap ng mga opsyon para sa Level 2 EV charger na akma sa mga pangangailangan ng iyong tahanan at mga kagustuhan sa EV. Ayusin ang mga filter upang i-personalize ang iyong mga resulta.',
  'homeChargers.title': 'Mga Charger sa Bahay',
  'homeChargers.toFullCharge': 'para mapuno ang karga',
  'homeChargers.wallMounted': 'Naka-mount',
  'homeChargers.wifi': 'Koneksyon sa WiFi',
  'homeChargersCard.beforeIncentives': 'Bago ang mga Insentibo',
  'homeChargersCard.buy': 'Tingnan ang mga Detalye',
  'homeChargersCard.socket': '{socket} Saksakan',
  'homeChargersCard.teslaWarning':
    'Gumagana lang ang charger na ito sa mga Tesla',
  'homepage.incentives.exporeIncentives': 'GALUGARIN ANG MGA INSENTIBO',
  'homepage.incentives.subTitle':
    'Tingnan kung magkano ang matitipid mo sa pagmamaneho ng EV, bumibili ka man o nagpapaupa. {lineBreak} Ang mga insentibo ay naka-personalize para sa lugar na iyong tinitirhan.',
  'homepage.incentives.title':
    'Galugarin ang mga potensyal na insentibo sa EV at mga kredito sa buwis',
  'homepage.linkCard.browseElectricVehicles':
    'MAG-BROWSE NG MGA SASAKYAN NA DE-KURYENTE {lineBreak}',
  'homepage.linkCard.discoverIncentives':
    'TUKLASIN ANG {lineBreak} MGA INSENTIBO',
  'homepage.linkCard.findDealers': 'Maghanap ng mga Dealer sa {lineBreak}',
  'homepage.linkCard.homeChargers': 'MGA CHARGER NG BAHAY {lineBreak}',
  'homepage.linkCard.locateChargingStations':
    'HANAPIN ANG MGA ISTASYON NG PAG-CHARGE {lineBreak}',
  'homepage.vehicleCarousel.findEVButton': 'Tingnan ang lahat ng sasakyan',
  'homepage.vehicleCarousel.subTitle':
    'Pumili ng EV at ihambing ang presyo sa isang katulad na sasakyang de-gas. Makakatulong sa iyo ang mga EV na makatipid ng pera dahil {lineBreak} kadalasan ay mas mura ang mga ito angkinin at panatilihin kaysa sa isang kakumpitensyang 100% pinapagana ng gasolina.',
  'homepage.vehicleCarousel.title':
    'May mga {vehicleCount} na sasakyang de-kuryente na magagamit. Tuklasin ang sa iyo.',
  'homepage.welcome': 'Colton Recharged',
  'homepage.welcomeSub':
    'Ang iyong gabay sa electric car, hatid sa iyo ng Colton Electric Utility. Tantyahin at ihambing ang mga gastos, matitipid, mga insentibo sa EV, at marami pang iba.',
  'homepage.zipcode.disclaimer':
    'Mga personalized na plano sa pagpepresyo sa loob ng wala pang 1 minuto. Hindi kinakailangan ang pag-signup.',
  'homepage.zipcode.getStarted': 'Magsimula',
  'homepage.zipcode.subtitle':
    'Malinaw na tutukuyin ng tool na ito ang pinakamababang presyo ng plano para sa EV.',
  'homepage.zipcode.title':
    "Alam mo ba na nag-aalok kami ng iba't ibang plano sa pagpepresyo ng kuryente? Hanapin ang pinakamahusay na plano sa pagpepresyo ng EV para sa iyo.",
  homeWiring: 'PAGKAKAWIRE SA BAHAY',
  incentives: 'Mga Insentibo',
  'incentives.clunkerNone':
    'Ang ilang mga insentibo ay nagbabayad sa iyo para sa pagreretiro ng isang umiiral na sasakyan, na kilala rin bilang clunker.',
  'incentives.clunkertoolTip':
    'Ang ilang mga insentibo ay nagbabayad sa iyo para sa pagreretiro ng isang umiiral na sasakyan, na kilala rin bilang clunker. Partikular, ang',
  'incentives.clunkertoolTipContd':
    'ay makukuha sa inyong rehiyon. Ang mga kinakailangan sa pagiging kwalipikado ay nag-iiba depende sa insentibo; pakitingnan ang mga detalye ng programa.',
  household_income_tooltip:
    'Pagsamahin ang kita ng lahat ng miyembro ng sambahayan. Ginagamit upang matukoy ang pagiging karapat-dapat sa insentibo.',
  household_size_tooltip:
    'Ginagamit upang matukoy ang pagiging karapat-dapat sa insentibo. Isama ang lahat ng miyembro ng iyong sambahayan (asawa, mga dependent, atbp.). Kaunti o walang insentibo ang tumutukoy sa mga sambahayang may higit sa 8 miyembro, kaya piliin ang 8 kung ang laki ng iyong sambahayan ay 8 o higit pa.',
  'incentives.electricityProvider': 'Tagapagbigay ng Elektrisidad',
  'incentives.headOfHousehold': 'Pinuno ng Sambahayan',
  'incentives.householdIncome': 'Kita ng Sambahayan',
  'incentives.householdIncomeTooltip':
    'Ginagamit upang matukoy ang pagiging karapat-dapat sa insentibo. Isama ang lahat ng miyembro ng iyong sambahayan (asawa, mga dependent, atbp.). Iilan o walang insentibo ang bumabanggit sa mga sambahayang mas malaki sa 8 miyembro, kaya pumili ng 8 kung ang laki ng iyong sambahayan ay 8 o mas malaki.',
  'incentives.householdSize': 'Laki ng Sambahayan',
  'incentives.householdSizeTooltip':
    'Isama ang lahat ng miyembro ng iyong sambahayan (asawa, mga deoendante, atbp). Ginagamit upang matukoy ang pagiging karapat-dapat sa insentibo.',
  'incentives.incentiveEligibility':
    'I-update ang Pagiging Karapat-dapat sa Insentibo',
  'incentives.income': 'Katayuan sa kita at buwis',
  'incentives.incomeTooltip':
    'Ang pagiging karapat-dapat sa insentibo at ang halagang maaari mong matanggap ay kadalasang nakadepende sa iyong kita. Ang mga customer na may mas mababang kita ay karaniwang karapat-dapat para sa mas mataas na mga rebate.',
  'incentives.less': 'mas kaunti',
  'incentives.location': 'Lokasyon',
  'incentives.locationTooltip':
    'Maraming insentibo ang nakadepende sa kung saan ka nakatira. Ilagay ang iyong zipcode upang makatulong na matukoy kung anong mga insentibo ang magagamit sa lugar mo.',
  'incentives.married': 'May asawa',
  'incentives.more': '... higit pa',
  'incentives.planClunker': 'Plano mo bang magsumite ng isang clunker?',
  'incentives.retiringVehicleTooltip':
    'Maaaring kailanganin ang pagreretiro ng isang lumang sasakyang gumagamit ng gasolina para sa ilang partikular na insentibo.',
  'incentives.selectModel': 'Pumili ng Modelo',
  'incentives.selectTrim': 'Piliin ang Trim',
  'incentives.single': 'Isahan',
  'incentives.subTitle':
    'Maaari kang maging kwalipikado para sa mga insentibo na magbabawas sa gastos sa pagbili o pag-upa ng EV. Ayusin ang mga filter upang i-personalize ang iyong mga resulta at i-click ang bawat tile upang matuto nang higit pa.',
  'incentives.taxFilingStatus': 'Katayuan ng Pag-file ng Buwis',
  'incentives.taxFilingStatusTooltip':
    'Ginagamit upang matukoy ang pagiging karapat-dapat sa insentibo.',
  'incentives.title': 'Mga Insentibo sa Sasakyang De-kuryente',
  'incentives.tradeIn': 'Ireretiro ang Isang Sasakyan?',
  'incentives.vehicleType': 'Uri ng Sasakyan',
  'incentives.vehicleTypeTooltip':
    'Ang ilang mga insentibo ay nakadepende sa kung aling kotse ang iyong bibilhin.',
  'incentives.whichVehicle': 'Aling sasakyan ang plano mong bilhin?',
  'incentiveSort.aToZ': 'Alpabeto: A hanggang Z',
  'incentiveSort.largest': 'Pinakamalaki Una',
  'incentiveSort.zToA': 'Alpabeto: Z hanggang A',
  'input-zipcode-for-rate-comp-launch':
    'Ginagamit upang matukoy ang pagiging karapat-dapat sa insentibo. Isama ang lahat ng miyembro ng iyong sambahayan (asawa, mga dependent, atbp.). Iilan o walang insentibo ang bumabanggit sa mga sambahayang mas malaki sa 8 miyembro, kaya pumili ng 8 kung ang laki ng iyong sambahayan ay 8 o mas malaki.',
  install: 'I-INSTALL',
  kgperyear: 'kg/taon',
  kilometersShort: 'kilometro',
  lbsperyear: 'libra/taon',
  linkUnavailable: 'Hindi Magagamit ang Link sa Network',
  literperyear: 'L/taon',
  liveInResidenceState:
    'Nakatira sa isang tirahan na tumatanggap ng serbisyo ng kuryente mula sa Xcel Energy sa {stateName}',
  loading: 'Naglo-load',
  low: 'Mababa',
  m: 'm',
  make: 'Gumawa',
  maps: 'Mga Mapa',
  'matchScore.adjustment': 'Pagsasaayos',
  'matchScore.budget': 'Badyet',
  'matchScore.charging': 'Nagcha-charge',
  'matchScore.maxScore': 'Pinakamataas na Iskor',
  'matchScore.popover':
    'Ang iyong Match Score ay batay sa iyong mga napiling kagustuhan.',
  'matchScore.range': 'Saklaw',
  'matchScore.seats': 'Mga Upuan',
  'matchScore.title': 'Iskor ng Laban',
  'matchScore.totalScore': 'Kabuuang Iskor',
  'matchScore.yourScore': 'Ang Iyong Iskor',
  medium: 'Katamtaman',
  'miles-driven-annually-range_tooltip':
    'Batay sa mga pagtatantya ng Kagawaran ng Transportasyon ng karaniwang taunang milya na nailalakbay noong 2020, ang isang karaniwang driver ay umaabot ng humigit-kumulang 16,000 milya bawat taon.',
  milesDrivenAnnually_tooltip: 'Batay sa Kagawaran ng Transportasyon',
  milesWord: 'Milya',
  modal1:
    'Magkano ang karaniwang singil sa kuryente sa iyong buwanang bayarin?',
  modal10:
    'Tip: Ang isang karaniwang drayber ay naglalakbay nang humigit-kumulang 12,000 milya bawat taon.',
  modal11: 'Aling tagal ng pag-charge ang pinakaangkop para sa iyo?',
  modal12:
    'Tip: Ang pag-charge sa gabi (mula 12-6 a.m.) ang pinaka-epektibo. Maaari mong i-program ang iyong EV para mag-charge sa loob ng panahong pinakaangkop para sa iyo.',
  modal13: 'Lahat ng Oras',
  modal14: 'Ano ang kasalukuyan mong plano sa pagpepresyo?',
  modal15: 'Tip: Karamihan sa mga customer ay gumagamit ng TOU-DR1.',
  modal16:
    'Paalala: Para sa mga customer na may mga planong hindi EV pricing (kabilang ang DR, TOU-DR1 at DR-SES), ipinapalagay namin na kasalukuyan kang nagmamaneho ng sasakyang de-gas na may uri, tatak, at presyo na katulad ng EV na napili sa Hakbang 2 at ipinapakita ang mga natipid mula sa paglipat sa EV na ito. Para sa mga customer na may planong EV-TOU-5 pricing, ipinapalagay namin na pagmamay-ari mo na ang napiling EV at ipinapakita ang iyong kasalukuyang natipid kumpara sa mga planong hindi EV pricing.',
  modal2: 'Hakbang',
  modal3: 'ng',
  modal4: 'Susunod',
  modal5: 'Aling EV ang pagmamay-ari mo na o gusto mong bilhin/lease?',
  modal6:
    'Tip: Maaari mong isaayos ang mga filter na ito pagkatapos mong makita ang iyong mga resulta.',
  modal7:
    "Piliin ang iyong kasalukuyan o gustong EV para makita ang mga potensyal na matitipid sa iba't ibang plano sa pagpepresyo. Ang pagpili ng sasakyan ay nakakaapekto sa mga potensyal na matitipid sa singil sa kuryente dahil sa mga pagkakaiba sa performance at efficiency ng kuryente sa iba't ibang modelo.",
  modal8: 'NAKARAAN',
  modal9: 'Sa karaniwan, ilang milya kada taon ang iyong minamaneho?',
  model: 'Modelo',
  'model.year': 'Taon ng Modelo',
  month: 'buwan',
  monthWord: 'buwan',
  new: 'Bago',
  newVehicles: 'Mga Bagong Sasakyan',
  no: 'Hindi',
  overTenYears: 'MAHIGIT 10 TAON',
  pages: 'Mga Pahina',
  personalizeIncentives: 'I-personalize ang mga Insentibo',
  phevFuelType: 'Isaksak ang Hybrid',
  portionOfPublicCharging: 'Bahagi ng Pampublikong Pagsingil',
  portionOfPublicChargingTooltip:
    'Kung hindi ka makapag-charge sa bahay, kakailanganin mong mag-charge sa mga bayad na pampublikong charging station. Tantyahin kung ilang porsyento ng oras ng pag-charge ng EV ang maaaring ilaan sa mga bayad na pampublikong charging station sa halip na sa bahay.',
  'pre-owned': 'Segunda-manong Pag-aari',
  Preferredpartner: 'Ginustong Kasosyo',
  prefferedEvChargingTimeframe: 'MAS GUSTONG PANAHON NG PAG-CHARGE NG EV',
  prefferedEvChargingTimeframe_tooltip:
    'Ang pag-charge sa gabi (12-6 a.m.) ang pinaka-epektibo. Maaari mong i-program ang iyong EV para mag-charge sa panahong pinakaangkop para sa iyo.',
  prefferedEvMake: 'PINAKAMAHUSAY NA TATAK NG EV',
  prefferedEvMake_tooltip:
    'Paalala: Ipinapalagay namin na kasalukuyan kang nagmamaneho ng de-gas na kotse na may uri, tatak, at presyo na katulad ng sa napiling EV.',
  prefferedEvModel: 'MAS GUSTONG Modelo ng EV',
  'pricePanels.cash': 'Pera',
  'pricePanels.downPayment': 'Paunang Bayad',
  'pricePanels.downPaymentDescription': '10% ng MSRP kasama ang buwis',
  'pricePanels.firstLeasePayment': 'UNANG BAYAD SA PAG-UPA',
  'pricePanels.incentivesForLease': 'Mga Insentibo para sa Pag-upa',
  'pricePanels.lease': 'Pag-upa',
  'pricePanels.leasePayment': 'Bayad sa Pag-upa',
  'pricePanels.loan': 'Pautang',
  'pricePanels.loanPayment': 'Pagbabayad ng Pautang',
  'pricePanels.perMonth': '/ buwan',
  'pricePanels.seeAllCosts': 'Tingnan ang Lahat ng Gastos',
  'pricePanels.seeAllIncentives': 'Tingnan ang Lahat ng Insentibo',
  'rateAdvisor.caption':
    'Ang tool na ito ng Savings Calculator ay ibinigay para sa mga layuning paglalarawan. Hindi ito isang pangako o garantiya na ang iyong aktwal na mga gastos sa pagsingil ay magiging katumbas ng mga gastos na ipinapakita sa tool. Hindi ginagarantiyahan ng SDG&E ang katumpakan, pagkakumpleto o kapakinabangan ng tinantyang impormasyon sa gastos. Hayagan na itinatatwa ng SDG&E ang pananagutan para sa anumang pinsala ng anumang uri na magmumula kaugnay ng paggamit ng tool na Savings Calculator. Ang iyong aktwal na mga gastos sa pagsingil ay mag-iiba batay sa ilang mga salik. Ang "SDG&E" ay tumutukoy sa San Diego Gas & Electric Company. ©2022 SDG&E. Lahat ng karapatan ay nakalaan.',
  'rateAdvisor.pricingPlanComparison': 'Paghahambing ng Plano ng Pagpepresyo',
  'rateAdvisor.sub':
    'Tukuyin ang iyong mga pagkakataon sa pagtitipid gamit ang isang EV. Ayusin ang mga filter upang makita ang iyong mga natipid.',
  'rateAdvisor.title': 'Kalkulador ng Pagtitipid',
  'rateComparison.youAreAlreadySaving':
    'Nakakatipid ka na ng hanggang {highlightText} kung mayroon kang EV at ginagamit ang {highlight} rate plan.',
  'rateComparison.youAreAlreadySavingVehicle':
    'Nakakatipid ka na ng hanggang {highlightText} kada taon sa {highlight} gamit ang isang {selectedVehicle}.',
  'rateComparison.youAreSaving':
    'Makakatipid ka ng hanggang {highlightText} kung mayroon kang EV at gagamitin ang {highlight} rate plan.',
  'rateComparison.youAreSavingVehicle':
    'Makakatipid ka ng {highlightText} kada taon sa {highlight} gamit ang isang {selectedVehicle}.',
  rateDRSESParagraph1:
    'Ang DR-SES ay ang plano para sa mga gumagamit ng solar at iba pang renewable energy.\nAng presyo ay batay sa oras at araw ng linggo, kasama ang kung gaano karaming kuryente ang iyong ginagamit. Ikaw',
  rateDRSESParagraph2:
    'Maaaring maging angkop ang planong ito para sa iyo kung gagawa ka ng renewable energy,\nkung maaari mong ilipat ang iyong mga aktibidad sa paggamit ng enerhiya sa bago mag-alas-4 ng hapon at pagkatapos ng alas-9 ng gabi, at kung maaari mong samantalahin ang mas murang kuryente sa mga oras na hindi peak hours.',
  rateEVTOU5Paragraph1:
    'Ang planong EV-TOU-5 ay para sa mga customer na mag-charge ng mga electric vehicle sa bahay.\nAng presyo ay batay sa kung gaano karaming kuryente ang iyong ginagamit at kung kailan, na may tatlong\npanahon ng pagpepresyo. Kapalit ng basic service fee, inaalok namin ang aming\npinakamababang rate para sa overnight EV charging sa bahay.',
  rateEVTOU5Paragraph2:
    'Maaaring maging angkop ang planong ito kung maaari mong ilipat ang ilan sa iyong gamit sa kuryente palayo sa mga oras na peak hours na 4-9 p.m. at maaari kang regular na mag-charge ng electric vehicle sa panahon na super off-peak sa gabi.',
  rateTOUDR1Paragraph1:
    'Ang presyo ng TOU-DR1 ay batay sa dami ng kuryenteng ginagamit mo, pati na rin sa oras at araw ng linggo kung kailan mo ito ginagamit. Sa tatlong panahon ng pagpepresyo, mayroong pagkakataong makatipid nang malaki sa gabi at katapusan ng linggo.',
  rateTOUDR1Paragraph2:
    'Maaaring maging angkop ang planong ito kung maaari mong ilipat ang ilan sa iyong ginagamit na kuryente palayo sa mga oras na peak hours na 4-9 p.m. at maaari mong samantalahin ang mas murang kuryente sa mga oras na hindi peak hours tuwing gabi at katapusan ng linggo.',
  regularResidential: 'Regular na Residensyal',
  'results.updated': 'Na-update na ang mga resulta noong',
  saved: 'na-save',
  'select-charger-level_tooltip':
    'Magiging mas maginhawa para sa iyo ang mas maraming sasakyang de-kuryente kung makakapag-charge ka nang mabilis sa bahay.',
  savingsGraphDisclaimer:
    '* Ipinapalagay na pinapagana mo ang iyong bahay gamit ang planong ito sa pagpepresyo at kasalukuyang nagmamaneho ng sasakyang de-gas na may uri, tatak, at presyo na katulad ng EV na iyong pinili.',
  savingsGraphEVLabel: 'Sasakyang De-kuryente',
  savingsGraphGasLabel: 'Gasolina',
  savingsGraphHomeLabel: 'Tahanan',
  savingsGraphYAxis: 'Tinatayang karaniwang gastos bawat taon',
  source: 'Pinagmulan',
  sources: 'mga mapagkukunan',
  'tabbed-maps-all-stations-tab': 'Mga Istasyon ng Pag-charge',
  'tabbed-maps-dealer-catalog-tab': 'Mga Dealer',
  'tabbed-maps-electricians-tab': 'Mga Elektrisyan',
  'tabbed-maps-route-tab': 'Magmapa ng Ruta',
  total: 'Kabuuan',
  trade_in_tooltip:
    'Maaaring kailanganin ang pag-retiro ng lumang sasakyang de-gasolina para sa ilang insentibo.',
  trim: 'Gupitin',
  type_tooltip:
    'Ang mga all-electric na sasakyan ay gumagamit lamang ng kuryente. Ang mga plug-in hybrid ay maaaring gumamit ng kuryente at gasolina.',
  Unfinished: 'Hindi pa tapos',
  updateZipcode: 'I-update ang Zip Code',
  usedElectricVehicles: 'Mga Gamit nang Sasakyang De-kuryente',
  'vehicle.afterIncentives': 'PAGKATAPOS NG MGA INSENTIBO',
  'vehicle.age.four': '4+ taong gulang',
  'vehicle.age.one': '0-1 taong gulang',
  'vehicle.age.two': '2-3 taong gulang',
  'vehicle.allElectric': 'Lahat ng Elektrisidad',
  'vehicle.batterySize': 'SUKAT NG BATERYA',
  'vehicle.bev': 'Elektrisidad',
  'vehicle.coTwoEmissions': 'PAGBABA NG MGA EMISYON NG CO2',
  'vehicle.electricRange': 'Saklaw ng Kuryente',
  'vehicle.estimatedIncentives': 'TINATAYANG MGA INSENTIBO',
  'vehicle.fewer': 'mas kaunti',
  'vehicle.fuelType': 'URI NG GASOLINA',
  'vehicle.gas': 'Gasolina',
  'vehicle.gasoline.metricPrice': 'Presyo ng Gasolina ($/L)',
  'vehicle.gasoline.price': 'Presyo ng Gasolina ($/gal)',
  'vehicle.greater': 'mas malaki',
  'vehicle.kilometers': 'kilometro',
  'vehicle.kilometersCapital': 'Kilometro',
  'vehicle.kilometersPerThirtyFastCharge':
    'Kilometro bawat 30 minuto ng mabilis na pag-charge',
  'vehicle.kilometersShort': 'kilometro',
  'vehicle.miles': 'milya',
  'vehicle.milesCapital': 'Milya',
  'vehicle.milesCaptital': 'Milya',
  'vehicle.milesPerThirtyFastCharge':
    'MILYA BAWAT 30 MINUTO NG MABILIS NA PAG-CHARGE',
  'vehicle.milesShort': 'milya',
  'vehicle.more': 'higit pa',
  'vehicle.msrp': 'MSRP',
  'vehicle.phev': 'Elektrisidad at Gasolina',
  'vehicle.plugInHybrid': 'Isaksak ang Hybrid',
  'vehicle.status': 'Katayuan ng Sasakyan',
  'vehicle.timeToChargeLvlTwo': 'ORAS NA PARA MAG-CHARGE - LEVEL 2',
  'vehicle.trees': 'mga puno',
  'vehicle.type': 'URI',
  'vehicle.type.coupe': 'Kupe',
  'vehicle.type.crossover': 'Pagtawid',
  'vehicle.type.hatchback': 'Hatchback',
  'vehicle.type.minivan': 'Minivan',
  'vehicle.type.sedan': 'Sedan',
  'vehicle.type.suv': 'SUV',
  'vehicle.type.truck': 'Trak',
  'vehicle.type.wagon': 'kariton',
  'vehicle.view': 'Tingnan',
  vehicles: 'Mga Sasakyan',
  'vehicles.new': 'Bago',
  'vehicles.none': 'Walang natagpuang sasakyan',
  'incentives.noneFound':
    'Walang insentibong tumugma sa iyong kasalukuyang mga filter. Subukang palawakin ang mga filter ng sasakyan o pagiging karapat-dapat.',
  'vehicles.used': 'Ginamit',
  vehicleType:
    'Piliin ang lahat ng uri ng katawan ng sasakyan na interesado ka.',
  viewSavings: 'TINGNAN ANG MGA DISKWENTO',
  Website: 'Website',
  yes: 'Oo',
  youAreEligible: 'Ikaw',
  zipcode: 'ZIP CODE',
  zipCode: 'Zip Code',
};

export default FIL_CUSTOM;
